import { registerPropertyManagerSection } from '@/core';
import AssembleReferencePointPropertySection from '@/components/editor/property-manager/assemble-reference/AssembleReferencePointPropertySection.vue';

registerPropertyManagerSection({
  id: 'assembly-reference-point',
  title: '装配体基准点',
  order: 36,
  component: AssembleReferencePointPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) =>
    context.activeCommand === 'assembly-reference-point'
    || Boolean(context.assemblyReferencePointActive),
  onConfirm: (context) => {
    context.submitAssemblyReferencePoint?.();
  },
  onCancel: (context) => {
    context.cancelAssemblyReferencePoint?.();
  },
});
